/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
import {CommonService} from "../service/common";
declare var $:any;
@Component({
  templateUrl:'./badgeGitEdit.html'
})

export class BadgeGitEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location,
    private common:CommonService,
    private fileupload:FileUpload
  ){}

  private data:any={
    "id": "",
    "imageEn": "",
    "imageTc": "",
    "number": "",
    "status": "",
    "titleEn": "",
    "titleTc": "",
    "describeTc":"",
    "describeEn":""
  }

  private id:number = 0;

  private isCreate:boolean=false;

  ngOnInit(): void {
    this.getPath();
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });

    if(this.id!=0){
      this.getData();
    }else {
      this.isCreate = true;
    }
  }





  private getData():void{
    this.HttpService.getData(API.giftBadge+"/"+this.id).then(res=>{
      this.data = res.data;
      this.data.status = res.data.status == 1 ? true : false;
    })
  }

  // 获取图片路径
  private showImageEn:boolean = false;
  private showImageTc:boolean = false;
  private tempPath:string=API.getTemp;
  private imagePath:string='';
  private upload(name:string){
    let self=this;
    this.fileupload.upload(function (res) {
      let temRes=JSON.parse(res);
      if(temRes.status.code==0){
        switch (name){
          case 'imageEn':self.showImageEn=true;break;
          case 'imageTc':self.showImageTc=true;break;
        }
        self.data[name]=temRes.data.fileName;
      }
    });
  }

  private getPath():void{
    this.HttpService.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        console.log(res.data)
      })
  }


  private submit():void{
    this.HttpService.postData(API.giftCreateOrUpdate,{
      "id": this.id,
      "imageEn": this.data.imageEn,
      "imageTc":  this.data.imageTc,
      "number":  this.data.number,
      "status": this.data.status?1:0,
      "titleEn": this.data.titleEn,
      "titleTc":  this.data.titleTc,
      "describeEn":this.data.describeEn,
      "describeTc":this.data.describeTc,
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
      }else{
        alert(data.status.message);
      }
    });
  }


}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/gift/badgeGitEdit.component.ts